export default "__VITE_ASSET__CFKU3glq__"